import { Chip } from '@circlefin/components'
import useTranslation from 'next-translate/useTranslation'

import type { ChipProps } from '@circlefin/components/lib/Chip'
import type { BlockchainAddressStatus } from '@shared/graphql'

export interface AddressStatusProps {
  /**
   * Address status.
   */
  status: BlockchainAddressStatus
}

const ADDRESS_STATUS_VARIANT_MAPPING: Record<
  BlockchainAddressStatus,
  ChipProps['variant']
> = {
  ACTIVE: 'default/success',
  PENDING_ADDITIONAL_INFORMATION: 'default/accent-violet',
  PENDING_BENEFICIARY_INFORMATION: 'default/accent-violet',
  PENDING_VERIFICATION: 'default/accent-violet',
  ON_HOLD: 'default/info',
  UNSUPPORTED: 'default/error',
}

export const AddressStatus: React.FC<AddressStatusProps> = ({ status }) => {
  const { t } = useTranslation('address-book/components')

  return (
    <Chip
      data-testid="address-status-chip"
      variant={ADDRESS_STATUS_VARIANT_MAPPING[status]}
    >
      {t(`addressStatus.${status}`)}
    </Chip>
  )
}
